export default __webpack_public_path__ + "static/media/handscross.9356f087.png";